export const mapLanguageToUrlSegment = (language: string) => {
    // TODO more sophisticated solution? Depends on how other language codes
    // are formatted. Currently we expect something like "sv-SE" and strip "-SE"
    if (!language || language.indexOf("-") === -1) {
        return language;
    }

    return language.split("-")[0];
};